<div *ngIf="listOnly; else quizTypeSelect">
    {{ quizTypeControl.value?.title }}
</div>
<ng-template #quizTypeSelect>
    <mat-form-field>
        <mat-select placeholder="Quiz Type" name="quiztype" [formControl]="quizTypeControl" [disabled]="canEdit === false">
            <mat-select-trigger>
                {{ quizTypeControl.value?.title }}
            </mat-select-trigger>
            <mat-option *ngFor="let option of options" [value]="option">
                {{option.title}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>
